export const MODULE_C = "MODULE_C";
export const COURSEID = "COURSEID";
export const CURRENTTAB = "CURRENTTAB";
export const ADDASSESSMENT = "ADDASSESSMENT";
export const CHECKSTATE = "CHECKSTATE";
export const ISUPDATEQUIZ = "ISUPDATEQUIZ";
